module.exports = __webpack_public_path__ + "static/media/muisti-logo.1956c01e.png";